import { transform, isNumber, isString } from 'lodash-es';
import {
  TagsType,
  StringTags,
  HighlightLogger,
  ErrorLevel,
  PromptParams,
} from './types';

// type of value must be string
export const parseTags = (tags: TagsType, omitNumber = false) =>
  transform(
    tags,
    (res: StringTags, value, key) => {
      if (typeof value === 'object') {
        return;
      }
      if (key.startsWith('__')) {
        console.error(
          'key in slardar tags which started with "__" is not allowed',
          key,
        );
        return;
      }

      if (omitNumber && isNumber(value)) {
        return;
      }

      try {
        const strValue = isString(value) ? value : JSON.stringify(value);
        res[key] = strValue;
      } catch (error) {}
    },
    {},
  );

/**
 * local log info
 * @param args
 */
export const print = (...args: any[]) => {
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
};

/**
 * highlight local log info
 * @param info
 * @param args
 */
export const prettyPrint: HighlightLogger = (info, ...args) => {
  if (process.env.NODE_ENV !== 'production') {
    const { label, bold = true, color } = info;

    const colorStyle = color ? `color: ${color};` : '';
    const boldStyle = bold ? 'font-weight: bold;' : '';

    // eslint-disable-next-line no-console
    console.log(`%c${label}`, `${colorStyle} ${boldStyle}`, ...args);
  }
};

export const level2color = (level: ErrorLevel) => {
  switch (level) {
    case 'fatal':
      return '#f00';
    case 'error':
      return '#e33';
    case 'warn':
      return '#f4bd02';

    default:
      return '';
  }
};

export const convertResponseInfo = (
  responseInfo?: PromptParams['responseInfo'],
): PromptParams['responseInfo'] | undefined => {
  try {
    if (!responseInfo) {
      return undefined;
    }
    const { errorCode } = responseInfo ?? {};
    if (errorCode === undefined) {
      return responseInfo;
    }
    return {
      ...responseInfo,
      errorCode: `${errorCode ?? -1}`,
    };
  } catch (err) {
    return undefined;
  }
};
